class BaseStage {
    /** @var {GlobalState} */
    globalState;
    /** @var {HTMLElement} */
    domContainer

    constructor(globalState) {
        this.globalState = globalState;
    }

    getStageKey() {
        // Each child should take care of retrieving and
        // initializing it's related dom container
        throw 'Attempting to retrieve undefined stage key'
    }

    display() {
        this.domContainer.classList.remove('d-none');
    };

    /**
     * Initializes all default components shared by all stages
     */
    initSharedComponents() {
        this.setupStageManagerButtons();
    }

    setupStageManagerButtons() {
        this.nextButton = this.domContainer.querySelector('button.next-stage-button');
        this.previousButton = this.domContainer.querySelector('button.previous-stage-button');

        if (this.nextButton) {
            this.nextButton.addEventListener('click', () => {
                this.globalState.stageManager.nextStage();
            })

            // Disable next step by default
            this.disableNextStageButton()
        }

        if (this.previousButton) {
            this.previousButton.addEventListener('click', () => {
                this.globalState.stageManager.previousStage();
            })
        }
    }

    enableNextStageButton() {
        this.nextButton.disabled = false;
    }

    disableNextStageButton() {
        this.nextButton.disabled = true;
    }

    clearDom() {
        // Each method clears its own DOM elements if required
    }
}

export {BaseStage};
